import { BaseApiService } from '@/services/base-service';
import { Filters, FiltersPagination, Response } from '@/types';
import { CoursesRequestStatuses } from '@/enums';
import { CoursesRequests } from '../types';

export class CoursesRequestsService extends BaseApiService {
  private readonly base_path = 'courses_requests';

  async get_courses_requests(filters: FiltersPagination<Filters>): Promise<CoursesRequests.List> {
    const payload = filters;

    const { data } = await this.http_client.get<CoursesRequests.List>(this.base_path, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async delete_courses_request(id: string| number): Promise<void> {
    const url = `${this.base_path}/${id}`;

    await this.http_client.delete(url);
  }

  async get_courses_request(id: string | number): Promise<Response<CoursesRequests.Item>> {
    const url = `${this.base_path}/${id}`;
    const { data } = await this.http_client.get<Response<CoursesRequests.Item>>(url);

    return data;
  }

  // ----------------------------------------Courses----------------------------------------

  async get_courses(filters: FiltersPagination<Filters>, request_id: number): Promise<CoursesRequests.CoursesResponse> {
    const url = `${this.base_path}/${request_id}/courses`;
    const payload = filters;

    const { data } = await this.http_client.get<CoursesRequests.CoursesResponse>(url, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  // ----------------------------------------Staffs----------------------------------------

  async get_staffs(filters: FiltersPagination<Filters>, request_id: string | number, filters_exist: boolean): Promise<CoursesRequests.StaffsResponse> {
    const url = `${this.base_path}/${request_id}/staff`;
    const payload = filters;

    const { data } = await this.http_client.get<CoursesRequests.StaffsResponse>(url, {
      params: {
        filters: payload.filters,
        filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  // ----------------------------------------History----------------------------------------

  async get_history(filters: FiltersPagination<Filters>, request_id: string | number): Promise<CoursesRequests.HistoryResponse> {
    const url = `${this.base_path}/${request_id}/history`;
    const payload = filters;

    const { data } = await this.http_client.get<CoursesRequests.HistoryResponse>(url, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }
}

export const default_courses_request = (): CoursesRequests.Item => ({
  id: 0,
  external_number: 0,
  date: '',
  total_amount: 0,
  quantity_courses: 0,
  quantity_staff: 0,
  order_number: '',
  name_organization: '',
  organization: {
    id: 0,
    name_organization: '',
  },
  status: {
    name: '',
    slug: CoursesRequestStatuses.DRAFT,
  },
  order_status: {
    name: '',
    slug: CoursesRequestStatuses.DRAFT,
  },
  order_total_amount: 0,
  has_unread_change: false,
});

export const default_staffs_filters = (): CoursesRequests.StaffsFilters => ({
  courses_ids: [],
  staffs_ids: [],
});

export const default_staffs_table_filters = (): CoursesRequests.StaffsTableFilters => ({
  courses: [],
  staffs: [],
});
